<template>
  <div>
    <b-modal id="addAddress" size="lg" :title="$t('addresses.add_title')" ref="modalAddAddress" @ok="handleStoreAddress" :ok-title="$t('buttons.ok')" :cancel-title="$t('buttons.cancel')"  @ok-disabled="isProcessing">
      <b-tabs content-class="mt-3">
        <b-tab title="Должника" active @click="toogleStoreDebtor(true)">
          <div class="form-group">
            <label for="StoreAddress" class="col-form-label">{{ $t('addresses.address') }}</label>
            <input type="text" class="form-control" v-model="storeaddress.address" :class="{'is-invalid': errors.address }" id="StoreAddress">
            <span v-if="errors.address" class="invalid-feedback">
                <strong>{{ errors.address ? errors.address[0] : '' }}</strong>
            </span>
          </div>
          <div class="form-group">
            <label for="StoreType" class="col-form-label">{{ $t('app.type') }}</label>
            <select v-model="storeaddress.type_id" class="form-control" id="StoreType" :class="{'is-invalid': errors.type_id }">
              <option selected="true" value="" disabled>{{ $t('placeholder.select_type') }}</option>
              <option v-for="type in listAddressTypes" :value="type.id" >
                {{ type.name }}
              </option>
            </select>
            <span v-if="errors.type_id" class="invalid-feedback">
                <strong>{{ errors.type_id ? errors.type_id[0] : '' }}</strong>
            </span>
          </div>
        </b-tab>
        <b-tab title="Контактного лица" @click="toogleStoreDebtor(false)">
          <div class="form-group">
            <label for="StoreContactfaceAddress" class="col-form-label">{{ $t('addresses.address') }}</label>
            <input type="text" class="form-control" v-model="storeaddress.address" :class="{'is-invalid': errors.address }" id="StoreContactfaceAddress">
            <span v-if="errors.address" class="invalid-feedback">
                <strong>{{ errors.address ? errors.address[0] : '' }}</strong>
            </span>
          </div>
          <div class="form-group">
            <label for="StoreContactfaceAddressType" class="col-form-label">{{ $t('app.type') }}</label>
            <select v-model="storeaddress.type_id" class="form-control" id="StoreContactfaceAddressType" :class="{'is-invalid': errors.type_id }">
              <option selected="true" value="" disabled>{{ $t('placeholder.select_type') }}</option>
              <option v-for="type in listAddressTypes" :value="type.id" >
                {{ type.name }}
              </option>
            </select>
            <span v-if="errors.type_id" class="invalid-feedback">
                <strong>{{ errors.type_id ? errors.type_id[0] : '' }}</strong>
            </span>
          </div>
          <div class="form-group">
            <label for="StoreContactface"> {{ $t('contact_faces.new') }}</label>
            <div class="input-group mb-3">
              <input type="text" class="form-control" v-model="storeaddress.contactfacename"  id="StoreContactface" :placeholder="$t('placeholder.enter_contact_face_fullname')" :class="{'is-invalid': errors.contactfacename }">
              <span v-if="errors.contactfacename" class="invalid-feedback">
                  <strong>{{ errors.contactfacename ? errors.contactfacename[0] : '' }}</strong>
              </span>
            </div>
          </div>
          <div class="form-group">
            <label for="storecontype" class="col-form-label">{{ $t('contact_faces.type') }}</label>
            <select class="form-control" id="storecontype" v-model="storeaddress.contactface_type" :class="{'is-invalid': errors.contactface_type }">
                <option selected="true" value="" disabled>{{ $t('placeholder.select_contactface_type') }}</option>
                <option v-for="type in listContactfaceTypes" v-bind:value="type.id">
                  {{type.name}}
                </option>
            </select>
            <span v-if="errors.contactface_type" class="invalid-feedback" >
                <strong>{{ errors.contactface_type ? errors.contactface_type[0] : '' }}</strong>
            </span>
          </div>
        </b-tab>
      </b-tabs>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      storeaddress: {
        debtor_iin: '',
        address: '',
        type_id: '',
        contactfacename: '',
        contactface_id: '',
        contactface_type: '',
        is_debtor: true
      },
      errors: {},
      isProcessing: false,
    }
  },
  computed: {
    ...mapGetters([
      'listAddressTypes',
      'listContactfaceTypes',
      'debt',
    ]),
  },
  mounted() {
      this.GET_LIST_ADDRESS_TYPES();
      this.GET_LIST_CONTACTFACE_TYPES();
  },
  methods: {
    ...mapActions([
      'GET_LIST_ADDRESS_TYPES',
      'STORE_ADDRESSES',
      'GET_LIST_CONTACTFACE_TYPES',
      'GET_ADDRESSES',
    ]),

    clearAddressModal() {
      this.storeaddress = {
        debtor_iin: '',
        address: '',
        type_id: '',
        contactfacename: '',
        contactface_id: '',
        contactface_type: '',
        is_debtor: true,
      };
      this.errors = {};
    },

    toogleStoreDebtor(is_debtor) {
      this.clearAddressModal();
      this.storeaddress.is_debtor = is_debtor;
    },

    handleStoreAddress (evt) {
      evt.preventDefault();
      this.storeAddress();
      this.isProcessing = true;
    },

    storeAddress() {
      this.storeaddress.debtor_iin = this.debt.debtor_iin;
      this.STORE_ADDRESSES(this.storeaddress)
        .then(() => {
            this.$refs.modalAddAddress.hide();
            this.GET_ADDRESSES(this.storeaddress.debtor_iin);
            this.clearAddressModal();
        })
        .catch((err) => {
           this.errors = this.laravelValidation(err);
        })
        .finally(() => {
            this.isProcessing = false;
        });
    },
  }
}
</script>
